export type BooleanSwitchProps<T extends object = object> = React.PropsWithChildren<{
  trueContent?: React.FC<T>;
  falseContent?: React.FC<T>;
  value: boolean | null;
  propsToBind: T;
}>;
export function BooleanSwitch<T extends object = object>({
  value,
  children,
  trueContent: TrueContent,
  falseContent: FalseContent,
  propsToBind,
}: BooleanSwitchProps<T>) {
  return (
    <>
      {value === true && typeof TrueContent === 'function' && <TrueContent {...propsToBind}>{children}</TrueContent>}
      {value === false && typeof FalseContent === 'function' && (
        <FalseContent {...propsToBind}>{children}</FalseContent>
      )}
    </>
  );
}
